import { ROLES } from 'config';

const settingsConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('settings', {
      url: '/settings',
      template: '<app-settings></app-settings>',
      access: {
        loginRequired: true,
        roles: [ROLES.USER, ROLES.ADMIN],
      },
      resolve: {
        // used to set the page title
        $title: () => 'Perfil',
      },
    });
};

export default settingsConfig;



// WEBPACK FOOTER //
// ./src/modules/settings/settings.config.js